// @ts-check
import React from 'react';
import { Page, Box } from '../../../pdf-design-system';
import useRoom from '../useRoom';
import theme from './vievinumTheme';

/**
 * @param {{
 *  children: React.ReactNode;
 *  bleed?: number;
 *  style?: import('@react-pdf/types').Style;
 *  [x: string]: any
 * }} props
 */
export default function VieVinumPageFrame({
  children,
  bleed = 0,
  style,
  ...rest
}) {
  const room = useRoom();
  if (bleed) {
    return (
      <Page
        size={{ width: `${162 + 2 * bleed}mm`, height: `${234 + 2 * bleed}mm` }}
        style={[
          { paddingVertical: `${bleed}mm`, paddingHorizontal: `${bleed}mm` },
          style,
        ]}
        theme={{ ...theme, colors: { ...theme.colors, ...room?.colors } }}
      >
        <Box
          style={{
            paddingHorizontal: '9mm',
            paddingVertical: '8mm',
            height: '234mm',
            position: 'relative',
          }}
          {...rest}
        >
          {children}
        </Box>
      </Page>
    );
  }
  return (
    <Page
      size={{ width: '162mm', height: '234mm' }}
      style={[{ paddingHorizontal: '9mm', paddingVertical: '8mm' }, style]}
      theme={{ ...theme, colors: { ...theme.colors, ...room?.colors } }}
      {...rest}
    >
      {children}
    </Page>
  );
}
